import React, { useState } from 'react';
import { useAuth } from '@context/AuthContext'; // Import the custom hook
import { validateEmailFormat } from '@/utils/Index';
import toast from 'react-hot-toast';

const ForgotForm = ({ onSwitchForm }) => {
  const { forgot } = useAuth(); // Destructure the `forgot` function from useAuth

  const logo =
    'https://firebasestorage.googleapis.com/v0/b/smartdog-bbe9f.firebasestorage.app/o/images%2Flogo-full.jpg?alt=media&token=685d3267-d81d-4256-b88c-f776c0e08363';
  // State for email and its validation
  const [email, setEmail] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [showInvalidEmailTooltip, setShowInvalidEmailTooltip] = useState(false);
  const [authError, setAuthError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  /**************************************************************************************** 
    Validate email input
  ****************************************************************************************/
  const handleEmailChange = (email) => {
    setEmail(email);

    // Validate email format
    const isValid = validateEmailFormat(email);
    setIsEmailValid(isValid);
    setShowInvalidEmailTooltip(!isValid);
  };

  /**************************************************************************************** 
    Handle Forgot Password
  ****************************************************************************************/
  const handleForgotPassword = async () => {
    if (!isEmailValid) {
      toast.error('Please enter a valid email address.');
      return;
    }

    setIsSubmitting(true);
    try {
      await forgot(email);
      setAuthError(null);
      toast.success('Password reset email sent. Check your inbox!');
    } catch (err) {
      console.error('Forgot password error:', err.message);
      setAuthError('Unable to send reset email. Please try again.');
      toast.error('Failed to send reset email.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className='authentication-bg min-vh-100'>
      <div className='bg-overlay bg-light'></div>
      <div className='container'>
        <div className='d-flex flex-column min-vh-100 px-3 pt-4'>
          <div className='row justify-content-center my-auto'>
            <div className='col-md-8 col-lg-6 col-xl-5'>
              <div className='card'>
                <div className='card-body p-4'>
                  <div className='text-center mt-2'>
                    <img src={logo} alt='' width='300' className='mb-3' />
                    <h5>Forgot Your Password?</h5>
                  </div>
                  <div className='p-2 mt-4'>
                    {/* Email Input */}
                    <div className='form-floating mb-3 position-relative'>
                      <input
                        type='email'
                        className='form-control'
                        placeholder='Email'
                        value={email}
                        onChange={(e) => handleEmailChange(e.target.value)}
                      />
                      <label className='form-label'>Email</label>
                      {/* Tooltip for invalid email */}
                      {showInvalidEmailTooltip && !isEmailValid && (
                        <div
                          className='invalid-overlay'
                          style={{
                            position: 'absolute',
                            top: '100%',
                            left: '20%',
                            backgroundColor: '#FDF3D7',
                            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                            padding: '5px 15px',
                            zIndex: 10,
                            width: 'auto',
                            borderRadius: '9999px',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          <ul className='list-unstyled mb-0'>
                            <li
                              className='requirements'
                              style={{ color: '#927422' }}
                            >
                              <i className='fas fa-times text-warning me-3'></i>
                              Invalid email
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>

                    {/* Submit Button */}
                    <div className='mt-3'>
                      <button
                        onClick={handleForgotPassword}
                        className='btn btn-primary w-100'
                        disabled={!isEmailValid || isSubmitting}
                      >
                        {isSubmitting ? 'Submitting...' : 'Send Reset Email'}
                      </button>
                    </div>

                    <div className='mt-4 text-center'>
                      <p className='mb-0'>
                        Forget it. Send me back to{' '}
                        <a
                          href='#'
                          onClick={() => onSwitchForm('login')}
                          className='fw-medium text-primary'
                        >
                          Login
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-lg-12'>
              <div className='text-center p-4'>
                <p>
                  Copyright © Smart Dog - All Rights Reserved -
                  <a
                    href='https://www.sis-smartdog.com'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    www.sis-smartdog.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotForm;
